<script>
    export default {
        data() {
            return {
                start_age: 0,
                end_age: 100,
            }
        },
        methods: {
            filterAges(start,end) {
                if (!$('#age_' + start + '_id').hasClass('active-invitation-tags')) {
                    this.start_age = start;
                    this.end_age = end;
                    $('.invitation-tags').removeClass('active-invitation-tags');
                    $('#age_' + start + '_id').addClass('active-invitation-tags');
                }
                else {
                    $('.invitation-tags').removeClass('active-invitation-tags');
                    this.start_age = 0;
                    this.end_age = 100;
                }
            },
            getAgeTagId(start) {
                return `age_${start}_id`;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/seo/SeoAgeContainer.vue